
function getVymeraString(vymera) {
    return vymera.toLocaleString('cs-CZ');
}

function getVymeraStringWithUnit(vymera) {
    return `${getVymeraString(vymera)} m2`;
}

function getVymeraStringWithUnitHa(vymera) {
    let vymeraHa = (vymera / 10000).toLocaleString(
        'cs-CZ',  {minimumFractionDigits:2, maximumFractionDigits:2}
    );
    return `${vymeraHa} ha`;
}

module.exports = {
    getVymeraString,
    getVymeraStringWithUnit,
    getVymeraStringWithUnitHa
};
